import { render, staticRenderFns } from "./DefaultImage.vue?vue&type=template&id=2ced88e2&scoped=true&"
import script from "./DefaultImage.vue?vue&type=script&lang=js&"
export * from "./DefaultImage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultImage.vue?vue&type=style&index=0&id=2ced88e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced88e2",
  null
  
)

export default component.exports